import React from "react";
import SVGMorph from "../SVGMorph";
import { deadLift1, deadLift3 } from "./path";

function DeadLift() {
  return (
    <svg
      style={{ width: "clamp(14.5625rem, 12.8191rem + 8.7168vw, 26.875rem)" }}
      viewBox="0 0 457 706"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SVGMorph
        paths={[deadLift1, deadLift3, deadLift1]}
        duration="0.4"
        delay="0.2"
      />
    </svg>
  );
}

export default DeadLift;
